"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = toArray;

// cheap conversion of an array-like object to Array instance
function toArray(object) {
  var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var length = object.length;
  var array = Array(length);

  for (var i = start; i < length; i++) {
    array[i - start] = object[i];
  }

  return array;
}
//# sourceMappingURL=toarray.js.map